
export const station_name = (item: any, t: any) => {
    // Applications
    //console.log(item);
    let name = '';
    let robots = item.hasOwnProperty('RN') ? item['RN'] : [];
    let apps = item.hasOwnProperty('AP') ? item['AP'] : [];
    let tags = item.hasOwnProperty('T') ? item['T'] : [];
    
    if (tags.includes("CAM")) {
        let tagscam = item.hasOwnProperty('TCM') ? item['TCM'] : [];
        //let application = t("application.Machining");
        /*if (tagscam.includes("Additive")) { // todo, currently no additive
            application = t("application.Additive Manufacturing");
        }*/

        // Translate apps
        tagscam = tagscam.map(function(arr) {  return t('applicationcam.' + arr); });

        if (tagscam.length > 3) {
            name = t('desc.CAM-n').replace(/\{apps\}/g, tagscam[0]);
        } else if (tagscam.length > 1) {
            name = t('desc.CAM-2')
                .replace(/\{app1\}/g, tagscam.slice(0, -1).join(', '))
                .replace(/\{app2\}/g, tagscam[tagscam.length - 1]);
        } else if (tagscam.length > 0) {
            name = t('desc.CAM-1').replace(/\{app1\}/g, tagscam[0]);
        }
    }
    if (name.length == 0){
        if (apps.length == 0) {
            name = "Generic sample"; // we should never get here
        } else {
            const curveFollowingTargets = [
                'Additive Manufacturing', 'Cutting', "Deburring", "Drawing",
                "Dispensing", "Drilling", "Engraving", "Finishing",
                "Grinding", "Inspection", 'Milling', 'Machining',
                "Painting", "Polishing", "Remote TCP", "Sanding",
                "Spraying", "Trimming", "Washing", "Welding"
            ];

            // Check if "Curve Following" exists and if any of the targets are also in apps
            const hasTargetApp = apps.some(app => curveFollowingTargets.includes(app));

            if (apps.includes("Curve Following") && hasTargetApp) {
                apps = apps.filter(item => item !== "Curve Following");
            }        
            if (apps.includes("Machining") && apps.includes("Milling")) {
                apps = apps.filter(item => item !== "Milling");
            }
            if (apps.includes("Collaborative")) {
                apps = apps.filter(item => item !== "Collaborative"); // Don't focus on this yet
            }
            let cadcam = false;
            if (apps.includes("CAD/CAM")) {
                cadcam = true;
                apps = apps.filter(item => item !== "CAD/CAM");
            }

            // Translate apps
            apps = apps.map(function(arr) {  return t('application.' + arr); });            

            if (apps.length > 3) {
                name = t("desc.apps-n").replace(/\{apps\}/g,apps[0]);
            } else if (apps.length > 1) {
                name = apps.slice(0, -1).join(', ') + ' ' + t("desc.and") + ' ' + apps[apps.length - 1];
            } else if (apps.length > 0) {
                name = apps[0];
            }
            if (cadcam) {
                name += " " + t("desc.usingCADCAM");
            }
        }
    }

    // add robot name info    
    if (robots.length > 0) {
        if (robots.length == 1) {
            name += " " + t("desc.wrobot").replace(/\{robot\}/g,robots[0]);
        } else { //if (robots.length > 1){
            name += " " + t("desc.wrobots").replace(/\{robot\}/g,robots[0]);
        }
    }    
    return name.trim();
}